/* Built In Imports */
/* External Imports */
import { Box, Heading, Text } from '@chakra-ui/react';
/* Internal Imports */
/* Components */
/* Styles */
import styles from "@lb/Sections/aboutDevi/styles.module.css"
/* Services */

const AboutDeviSlide15 = () => {
  return (
    <Box bgColor="#000" className={styles.section15Bg} overflow="hidden">
      <Box
        maxW="1200px"
        mx="auto"
        height="100%"
        display="flex"
        position="relative"
        alignItems="center"
        justifyContent="center"
        minH="100vh"
      >
        <Box
          maxW="500px"
          w="100%"
          textAlign="center"
          px={{ base: '16px', md: '10px' }}
          py="180px"
        >
          <Heading
            color="common.white"
            fontSize={{ base: '64px', lg: '100px' }}
            lineHeight={{ base: '60px', lg: '104px' }}
            fontFamily="'FedraSerifDisplay'"
            pb={4}
          >
            Darkness
          </Heading>
          <Text color="secondary.main" fontSize={{ base: '18px', lg: '24px' }}>
            is generally considered negative and can give rise to fear in some.
            But for those beyond fear, darkness represents that which both
            absorbs and gives birth to the world around us
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
export default AboutDeviSlide15;
